import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 当前区域状态管理
    currentRegion: {
      level: 'province', // 'province' | 'city'
      name: 'hunan', // 当前区域名称（拼音）
      mapName: '湖南省', // 当前区域中文名称
      adcode: '430000' // 当前区域代码
    },
    // 大屏数据
    screenData: {},
    // 图书多元（日/周/月）
    tushuduoyuan: {
      period: 'today',
      day: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
      week: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
      month: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 }
    },
    // 渠道销售占比数据
    channelSales: {
      period: 'today',
      channels: []
    },
    // 销售大类占比数据
    salesCategory: {
      period: 'today',
      categories: [
        { categoryId: '1', categoryName: '图书', salesAmount: 0, percentage: 0 },
        { categoryId: '2', categoryName: '多元', salesAmount: 0, percentage: 0 },
        { categoryId: '3', categoryName: '联营', salesAmount: 0, percentage: 0 }
      ]
    },
    // 单品种销售排行
    salesRanking: {
      period: 'week',
      rows: []
    },
    // 会员活跃趋势数据
    memberTrend: {
      dates: [],
      values: []
    },
    // 今日/周/月码洋总览及会员信息（从大屏数据派生）
    todaySales: {
      period: 'today',
      totalAmount: 0,
      amounts: { today: 0, week: 0, month: 0 },
      members: [],
      growth: 0
    },
    // 湖南地图数据（含时间维度与线上/线下总码洋）
    hunanMapData: {
      period: 'today',
      totals: { online: 0, offline: 0 },
      regions: [] // [{ cityName, onlineAmount, offlineAmount, totalAmount, ranking }]
    },
    // 教材征订统计
    textbookStatistics: {
      period: 'quarter', // 只显示最新季次
      totalOrders: 0,
      totalAmount2025: 0,
      autumnAmount25: 0,
      // 新增同比字段
      totalAmount2025Tb: 0,
      autumnAmount25Tb: 0
    },
    // 订单数及码洋同比
    orderComparison: {
      dates: [],
      orders: [],
      amounts: []
    },
    // 各市州渠道对比
    cityChannelComparison: {
      period: 'today',
      cities: []
    },
    // 数据加载状态
    loading: false,
    // 最后更新时间
    lastUpdateTime: null
  },
  mutations: {
    // 设置大屏全部数据
    SET_SCREEN_DATA(state, data) {
      state.screenData = data
    },
    // 设置当前区域状态
    SET_CURRENT_REGION(state, { level, name, mapName, adcode }) {
      state.currentRegion = {
        level: level || 'province',
        name: name || 'hunan',
        mapName: mapName || '湖南省',
        adcode: adcode || '430000'
      }
    },
    // 设置图书多元数据（日/周/月）
    SET_TUSHUDUOYUAN(state, payload) {
      const safeNum = v => {
        const n = Number(v)
        return isNaN(n) ? 0 : n
      }
      const normalize = obj => ({
        jybs: safeNum(obj?.jybs),
        zmy: safeNum(obj?.zmy),
        tbzmy: safeNum(obj?.tbzmy),
        hbzmy: safeNum(obj?.hbzmy)
      })
      if (payload?.day) state.tushuduoyuan.day = normalize(payload.day)
      if (payload?.week) state.tushuduoyuan.week = normalize(payload.week)
      if (payload?.month) state.tushuduoyuan.month = normalize(payload.month)
      if (payload?.period) state.tushuduoyuan.period = payload.period
    },
    // 设置渠道销售数据
    SET_CHANNEL_SALES(state, data) {
      state.channelSales = data
    },
    // 设置销售大类数据
    SET_SALES_CATEGORY(state, data) {
      state.salesCategory = data
    },
    // 设置单品种销售排行
    SET_SALES_RANKING(state, data) {
      state.salesRanking = data
    },
    // 设置会员趋势数据
    SET_MEMBER_TREND(state, data) {
      state.memberTrend = data
    },
    // 设置今日码洋数据
    SET_TODAY_SALES(state, data) {
      state.todaySales = data
    },
    // 设置湖南地图数据
    SET_HUNAN_MAP_DATA(state, data) {
      state.hunanMapData = data
    },
    // 设置教材征订统计
    SET_TEXTBOOK_STATISTICS(state, data) {
      state.textbookStatistics = data
    },
    // 设置订单码洋同比数据
    SET_ORDER_COMPARISON(state, data) {
      state.orderComparison = data
    },
    // 设置市州渠道对比数据
    SET_CITY_CHANNEL_COMPARISON(state, data) {
      state.cityChannelComparison = data
    },
    // 设置加载状态
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    // 更新最后更新时间
    SET_LAST_UPDATE_TIME(state, time) {
      state.lastUpdateTime = time
    },
    // 重置所有数据状态
    RESET_ALL_DATA(state) {
      console.log('重置所有数据状态...')
      // 重置当前区域状态
      state.currentRegion = {
        level: 'province',
        name: 'hunan',
        mapName: '湖南省',
        adcode: '430000'
      }
      // 重置图书多元
      state.tushuduoyuan = {
        period: 'today',
        day: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
        week: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
        month: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 }
      }
      // 重置渠道销售数据
      state.channelSales = {
        period: 'today',
        channels: []
      }
      // 重置销售大类数据
      state.salesCategory = {
        period: 'today',
        categories: [
          { categoryId: '1', categoryName: '图书', salesAmount: 0, percentage: 0 },
          { categoryId: '2', categoryName: '多元', salesAmount: 0, percentage: 0 },
          { categoryId: '3', categoryName: '联营', salesAmount: 0, percentage: 0 }
        ]
      }
      // 重置单品种销售排行
      state.salesRanking = {
        period: 'week',
        rows: []
      }
      // 重置会员趋势数据
      state.memberTrend = {
        dates: [],
        values: []
      }
      // 重置今日/周/月码洋数据与会员信息
      state.todaySales = {
        period: 'today',
        totalAmount: 0,
        amounts: { today: 0, week: 0, month: 0 },
        members: [],
        growth: 0
      }
      // 重置湖南地图数据
      state.hunanMapData = {
        period: 'today',
        totals: { online: 0, offline: 0 },
        regions: []
      }
      // 重置教材征订统计
      state.textbookStatistics = {
        period: 'quarter',
        totalOrders: 0,
        totalAmount2025: 0,
        autumnAmount25: 0
      }
      // 重置订单码洋同比数据
      state.orderComparison = {
        dates: [],
        orders: [],
        amounts: []
      }
      // 重置市州渠道对比数据
      state.cityChannelComparison = {
        period: 'today',
        cities: []
      }
    }
  },
  actions: {
    // 获取所有数据
    async fetchAllData({ dispatch, state }) {
      const maxRetries = 3
      let retryCount = 0
      
      while (retryCount < maxRetries) {
        try {
          // 根据当前区域状态获取大屏数据
          const regionParam = state.currentRegion.level === 'city' 
            ? { region: state.currentRegion.mapName } 
            : {}
          
          // 先获取大屏完整数据，确保派生字段可用
          await dispatch('fetchBigScreenData', regionParam)

          // 并发获取其他模块数据（不含渠道占比）
          await Promise.all([
            dispatch('fetchBookStatistics'),
            dispatch('fetchSalesCategory'),
            dispatch('fetchTodaySales'),
            dispatch('fetchHunanMapData'),
            dispatch('fetchTextbookStatistics'),
            dispatch('fetchOrderComparison'),
            dispatch('fetchCityChannelComparison')
          ])

          // 最后获取渠道占比（将优先使用大屏数据派生）
          await dispatch('fetchChannelSales')
          // 获取单品种销售排行（默认近7天）
          await dispatch('fetchSalesRanking')
          
          console.log('所有数据获取成功')
          return // 成功则退出重试循环
          
        } catch (error) {
          retryCount++
          console.error(`数据获取失败 (尝试 ${retryCount}/${maxRetries}):`, error)
          
          if (retryCount >= maxRetries) {
            console.error('达到最大重试次数，数据获取最终失败')
            throw error
          }
          
          // 等待一段时间后重试
          const delay = Math.min(1000 * Math.pow(2, retryCount - 1), 5000) // 指数退避，最大5秒
          console.log(`等待 ${delay}ms 后重试...`)
          await new Promise(resolve => setTimeout(resolve, delay))
        }
      }
    },
    // 获取大屏数据
    async fetchBigScreenData({ commit, state }, { region } = {}) {
      try {
        // const response = await this._vm.$api.getScreenData()
        // const response = await this._vm.$api.getScreenBigData() // --- 旧的接口
        let response
        
        // 根据区域参数决定使用哪个API
        if (region && region.trim()) {
          // 市级地图：传入城市名称参数
          response = await this._vm.$api.getScreenDataToV2(region.trim())
        } else {
          // 省级地图：不传参数
          response = await this._vm.$api.getScreenDataToV2()
        }
        
        // 规范化单品排行相关字段为数组
        const normalizeArray = (val) => {
          if (Array.isArray(val)) return val
          if (val && typeof val === 'object') return [val]
          return []
        }
        const normalized = {
          ...response,
          danpin_xiaoshou_week: normalizeArray(response?.danpin_xiaoshou_week),
          danpin_xiaoshou_month: normalizeArray(response?.danpin_xiaoshou_month),
          danpin_xiaoshou_halfyear: normalizeArray(response?.danpin_xiaoshou_halfyear)
        }
        commit('SET_SCREEN_DATA', normalized)
      } catch (error) {
        console.error('获取大屏数据失败:', error)
      }
    },
    // 更新当前区域状态
    updateCurrentRegion({ commit }, { level, name, mapName, adcode }) {
      commit('SET_CURRENT_REGION', { level, name, mapName, adcode })
      
      // 将区域状态保存到localStorage以支持页面刷新后恢复
      try {
        const regionState = { level, name, mapName, adcode }
        localStorage.setItem('currentRegion', JSON.stringify(regionState))
      } catch (error) {
        console.warn('保存区域状态到localStorage失败:', error)
      }
    },
    // 从localStorage恢复区域状态
    restoreRegionFromStorage({ commit }) {
      try {
        const savedRegion = localStorage.getItem('currentRegion')
        if (savedRegion) {
          const regionState = JSON.parse(savedRegion)
          commit('SET_CURRENT_REGION', regionState)
          return regionState
        }
      } catch (error) {
        console.warn('从localStorage恢复区域状态失败:', error)
      }
      return null
    },
    // 获取图书多元数据 （日/周/月）
    async fetchBookStatistics({ commit, state }) {
      try {
        const big = state.screenData || {}

        // 将可能带有逗号、百分号或中文单位（万、亿）的字符串统一转换为数值（单位：元）
        const safeNum = (v) => {
          if (v === null || v === undefined) return 0
          if (typeof v === 'number' && !isNaN(v)) return v
          const s = String(v).trim()
          if (!s) return 0
          // 去掉千位分隔与百分号
          const cleaned = s.replace(/,/g, '').replace(/%/g, '')
          // 处理中文单位：万、亿
          if (/万$/.test(cleaned)) {
            const n = parseFloat(cleaned.replace('万', ''))
            return isNaN(n) ? 0 : n * 10000
          }
          if (/亿$/.test(cleaned)) {
            const n = parseFloat(cleaned.replace('亿', ''))
            return isNaN(n) ? 0 : n * 100000000
          }
          const n = parseFloat(cleaned)
          return isNaN(n) ? 0 : n
        }

        // 规范化图书多元对象结构为 { jybs, zmy, tbzmy, hbzmy }
        const normalizeDU = (obj) => ({
          jybs: safeNum(obj?.jybs),     // 交易笔数（笔）
          zmy: safeNum(obj?.zmy),       // 总码洋（元）
          tbzmy: safeNum(obj?.tbzmy),   // 同比总码洋（元）
          hbzmy: safeNum(obj?.hbzmy)    // 环比总码洋（元）
        })

        // 从大屏数据派生各周期原始对象
        const dayRaw = big?.tushuduoyuan_day || {}
        const weekRaw = big?.tushuduoyuan_week || {}
        const monthRaw = big?.tushuduoyuan_month || {}

        const hasBigData = (
          dayRaw && Object.keys(dayRaw).length > 0 ||
          weekRaw && Object.keys(weekRaw).length > 0 ||
          monthRaw && Object.keys(monthRaw).length > 0
        )

        if (hasBigData) {
          // 使用大屏数据：清洗并入库（不改变当前 period）
          commit('SET_TUSHUDUOYUAN', {
            day: normalizeDU(dayRaw),
            week: normalizeDU(weekRaw),
            month: normalizeDU(monthRaw)
          })
        } else {
          // 回退旧接口：同样进行清洗与入库
          // const response = await this._vm.$api.getBookStatistics()
          const data = {}
          // 支持可能的字段命名差异（day/today）
          const dayApi = data?.day || data?.today || {}
          const weekApi = data?.week || {}
          const monthApi = data?.month || {}
          commit('SET_TUSHUDUOYUAN', {
            day: normalizeDU(dayApi),
            week: normalizeDU(weekApi),
            month: normalizeDU(monthApi)
          })
        }
      } catch (error) {
        console.error('获取图书统计数据失败:', error)
        // 失败时写入安全默认值，避免页面空白
        commit('SET_TUSHUDUOYUAN', {
          day: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
          week: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 },
          month: { jybs: 0, zmy: 0, tbzmy: 0, hbzmy: 0 }
        })
      }
    },
    // 获取渠道销售数据（支持静默刷新）
    async fetchChannelSales({ commit, state }, period = null) {
      try {
        // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
        const currentPeriod = period || state.channelSales.period || 'today'
        
        // 优先从大屏完整数据中派生渠道占比
        const mapPeriodKey = {
          today: { xianxia: 'qudaozhanbi_xianxia_day', ziying: 'qudaozhanbi_ziying_day', pixiao: 'qudaozhanbi_pixiao_day', pixiao_xx: 'qudaozhanbi_pixiao_xx_day' },
          week:  { xianxia: 'qudaozhanbi_xianxia_week', ziying: 'qudaozhanbi_ziying_week', pixiao: 'qudaozhanbi_pixiao_week', pixiao_xx: 'qudaozhanbi_pixiao_xx_week' },
          month: { xianxia: 'qudaozhanbi_xianxia_month', ziying: 'qudaozhanbi_ziying_month', pixiao: 'qudaozhanbi_pixiao_month', pixiao_xx: 'qudaozhanbi_pixiao_xx_month' }
        }
        const keys = mapPeriodKey[currentPeriod] || mapPeriodKey.today
        const bigData = state.screenData || {}
        // 先将原始值标准化为数值
        const safeNum = (v) => {
          const n = Number(v)
          return isNaN(n) ? 0 : n
        }
        const hasBigDataForPeriod = bigData && (bigData[keys.xianxia] !== undefined || bigData[keys.ziying] !== undefined || bigData[keys.pixiao] !== undefined || bigData[keys.pixiao_xx] !== undefined)

        if (hasBigDataForPeriod) {
          // 原始数值（可能为金额/数量），第三方默认 0
          const offlineVal = safeNum(bigData[keys.xianxia])
          const selfOpVal = safeNum(bigData[keys.ziying])
          const thirdVal = safeNum(bigData[keys.pixiao])
          const batchVal = safeNum(bigData[keys.pixiao_xx]) // 新增线下批销数据
          const total = offlineVal + selfOpVal + thirdVal + batchVal
          const toPercent = (val, sum) => sum > 0 ? Number(((val / sum) * 100).toFixed(2)) : 0
          const channels = [
            { channelName: '线下零售', percentage: toPercent(offlineVal, total) },
            { channelName: '自营平台', percentage: toPercent(selfOpVal, total) },
            { channelName: '第三方线上', percentage: toPercent(thirdVal, total) },
            { channelName: '线下批销', percentage: toPercent(batchVal, total) }
          ]
          commit('SET_CHANNEL_SALES', { period: currentPeriod, channels })
        } else {
          // 回退至原有渠道销售接口
          // const response = await this._vm.$api.getChannelSales(currentPeriod)
          const respData = {
            period: 'today',
            channels: [
              { channelName: '线下零售', percentage: 0 },
              { channelName: '自营平台', percentage: 0 },
              { channelName: '第三方线上', percentage: 0 },
              { channelName: '线下批销', percentage: 0 }
            ]
          }
          commit('SET_CHANNEL_SALES', { ...respData, period: currentPeriod })
        }
      } catch (error) {
        console.error('获取渠道销售数据失败:', error)
      }
    },
    // 获取单品种销售排行（支持静默刷新，使用大屏数据 danpin_xiaoshou_* 映射为表格行）
    async fetchSalesRanking({ commit, state }, period = null) {
      try {
        // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
        const currentPeriod = period || state.salesRanking.period || 'week'
        
        const mapPeriodKey = {
          week: 'danpin_xiaoshou_week',
          month: 'danpin_xiaoshou_month',
          halfyear: 'danpin_xiaoshou_halfyear'
        }
        const key = mapPeriodKey[currentPeriod] || mapPeriodKey.week
        const bigData = state.screenData || {}
        let list = bigData[key]

        const safeNum = (v) => {
          const n = Number(v)
          return isNaN(n) ? 0 : n
        }
        const formatPrice = (v) => {
          const n = safeNum(v)
          return n.toFixed(2)
        }
        const formatInt = (v) => {
          const n = safeNum(v)
          return String(Math.round(n))
        }

        if (!Array.isArray(list)) {
          list = list && typeof list === 'object' ? [list] : []
        }

        const rows = list.map((item, idx) => {
          const rank = idx + 1
          const rankHtml = rank <= 3
            ? `<span class=\"rank_card top3\">NO.${rank}</span>`
            : `<span class=\"rank_card\">NO.${rank}</span>`
          const name = String(item?.pm || item?.name || '')
          const price = formatPrice(item?.dj)
          const amount = formatPrice(item?.my)
          const qty = formatInt(item?.sl)
          return [rankHtml, name, price, amount, qty]
        })

        commit('SET_SALES_RANKING', { period: currentPeriod, rows })
      } catch (error) {
        console.error('获取单品种销售排行数据失败:', error)
        commit('SET_SALES_RANKING', { period: currentPeriod, rows: [] })
      }
    },
    // 获取销售大类数据（支持静默刷新，优先使用大屏数据 xiaoshou_dalei_zhanbi_*，缺失时回退到原 API）
    async fetchSalesCategory({ commit, state }, period = null) {
      try {
        // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
        const currentPeriod = period || state.salesCategory.period || 'today'
        
        const mapPeriodKey = {
          today: 'xiaoshou_dalei_zhanbi_day',
          week: 'xiaoshou_dalei_zhanbi_week',
          month: 'xiaoshou_dalei_zhanbi_month'
        }
        const key = mapPeriodKey[currentPeriod] || mapPeriodKey.today
        const bigData = state.screenData || {}
        const dalei = bigData[key]

        // 若大屏数据存在，则根据 dl 映射到 图书/多元/联营 三类，缺失默认 0，并计算百分比
        if (dalei && (Array.isArray(dalei) || typeof dalei === 'object')) {
          const safeNum = (v) => {
            const n = Number(v)
            return isNaN(n) ? 0 : n
          }

          const categories = [
            { categoryId: '1', categoryName: '图书', salesAmount: 0, percentage: 0 },
            { categoryId: '2', categoryName: '多元', salesAmount: 0, percentage: 0 },
            { categoryId: '3', categoryName: '联营', salesAmount: 0, percentage: 0 }
          ]

          const idxMap = { '图书': 0, '多元': 1, '联营': 2 }

          // 处理数组形式的数据
          if (Array.isArray(dalei)) {
            dalei.forEach(item => {
              if (item && typeof item === 'object') {
                const name = item.dl || ''
                const value = safeNum(item.my)
                const idx = idxMap[name]
                if (idx !== undefined) {
                  categories[idx].salesAmount = value
                }
              }
            })
          } else {
            // 处理单个对象形式的数据（保持向后兼容）
            const name = dalei.dl || ''
            const value = safeNum(dalei.my)
            const idx = idxMap[name]
            if (idx !== undefined) {
              categories[idx].salesAmount = value
            }
          }

          const total = categories.reduce((sum, c) => sum + safeNum(c.salesAmount), 0)
          categories.forEach((c) => {
            c.percentage = total > 0 ? Number(((safeNum(c.salesAmount) / total) * 100).toFixed(2)) : 0
          })

          commit('SET_SALES_CATEGORY', { period: currentPeriod, categories })
          return
        }

        // 回退到原 API
        // const response = await this._vm.$api.getSalesCategory(currentPeriod)
        const respData = {
          period: 'today',
          categories: [
            { categoryId: '1', categoryName: '图书', salesAmount: 0, percentage: 0 },
            { categoryId: '2', categoryName: '多元', salesAmount: 0, percentage: 0 },
            { categoryId: '3', categoryName: '联营', salesAmount: 0, percentage: 0 }
          ]
        }
        commit('SET_SALES_CATEGORY', { ...respData, period: currentPeriod })
      } catch (error) {
        console.error('获取销售大类数据失败:', error)
      }
    },
    // 获取会员趋势数据
    async fetchMemberTrend({ commit }) {
      try {
        const response = await this._vm.$api.getMemberTrend()
        commit('SET_MEMBER_TREND', response.data)
      } catch (error) {
        console.error('获取会员趋势数据失败:', error)
      }
    },
    // 获取今日/周/月码洋与会员信息（支持静默刷新，从 screenData 派生）
    async fetchTodaySales({ commit, state }, period = null) {
      try {
        // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
        const currentPeriod = period || state.todaySales.period || 'today'
        
        const big = state.screenData || {}
        const toNum = v => {
          const n = Number(v)
          return isNaN(n) ? 0 : n
        }
        const amounts = {
          today: toNum(big.today_mayang),
          week: toNum(big.week_mayang),
          month: toNum(big.month_mayang),
        }
        const displayAmount = amounts[currentPeriod]
        const members = Array.isArray(big.huiyuan)
          ? big.huiyuan.map(it => ({ type: it?.type || '', sl: toNum(it?.sl) }))
          : []
        commit('SET_TODAY_SALES', {
          period: currentPeriod,
          totalAmount: displayAmount,
          amounts,
          members,
          growth: 0
        })
      } catch (error) {
        console.error('派生今日/周/月码洋数据失败:', error)
      }
    },
    // 获取湖南地图征订数据（支持静默刷新，从 screenData 派生：按周期合并线上/线下并计算总额与排名）
    async fetchHunanMapData({ commit, state }, period = null) {
      try {
        // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
        const currentPeriod = period || state.hunanMapData.period || 'today'
        
        const big = state.screenData || {}
        // 选择周期对应的线上/线下数组
        let onlineArr = []
        let offlineArr = []
        switch (currentPeriod) {
          case 'today':
            onlineArr = Array.isArray(big.qudao_ri_xianshang) ? big.qudao_ri_xianshang : []
            offlineArr = Array.isArray(big.qudao_day_xianxia) ? big.qudao_day_xianxia : []
            break
          case 'week':
            onlineArr = Array.isArray(big.qudao_zhou_xianshang) ? big.qudao_zhou_xianshang : []
            offlineArr = Array.isArray(big.qudao_week_xianxia) ? big.qudao_week_xianxia : []
            break
          case 'month':
          default:
            onlineArr = Array.isArray(big.qudao_yue_xianshang) ? big.qudao_yue_xianshang : []
            offlineArr = Array.isArray(big.qudao_yue_xianxia) ? big.qudao_yue_xianxia : []
            break
        }

        const safeNum = (v) => {
          const n = Number(v)
          return isNaN(n) ? 0 : n
        }
        const nameOf = (item) => String(item?.name || item?.cityName || '').trim()

        // 聚合同名城市线上/线下金额（单位：元），兼容不同字段
        const onlineMap = new Map()
        const offlineMap = new Map()
        let totalOnline = 0
        let totalOffline = 0
        for (const it of onlineArr) {
          const nm = nameOf(it)
          if (!nm) continue
          const val = safeNum(it?.my || it?.sl || it?.salesAmount)
          onlineMap.set(nm, (onlineMap.get(nm) || 0) + val)
          totalOnline += val
        }
        for (const it of offlineArr) {
          const nm = nameOf(it)
          if (!nm) continue
          const val = safeNum(it?.my || it?.sl || it?.salesAmount)
          offlineMap.set(nm, (offlineMap.get(nm) || 0) + val)
          totalOffline += val
        }

        // 城市名全集
        const allNames = new Set([...onlineMap.keys(), ...offlineMap.keys()])
        const regions = Array.from(allNames).map(cityName => {
          const onlineAmount = onlineMap.get(cityName) || 0
          const offlineAmount = offlineMap.get(cityName) || 0
          const totalAmount = onlineAmount + offlineAmount
          return { cityName, onlineAmount, offlineAmount, totalAmount, ranking: 0 }
        })

        // 排名按总额降序
        regions.sort((a, b) => b.totalAmount - a.totalAmount)
        regions.forEach((r, idx) => { r.ranking = idx + 1 })

        commit('SET_HUNAN_MAP_DATA', {
          period: currentPeriod,
          totals: { online: totalOnline, offline: totalOffline },
          regions
        })
      } catch (error) {
        console.error('获取湖南地图征订数据失败:', error)
        commit('SET_HUNAN_MAP_DATA', { period: currentPeriod, totals: { online: 0, offline: 0 }, regions: [] })
      }
    },
    // 获取教材征订统计（支持静默刷新，优先使用大屏数据 jczhengding_* 字段派生）
    async fetchTextbookStatistics({ commit, state }, period = null) {
      try {
        // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
        const currentPeriod = period || state.textbookStatistics.period || 'quarter'
        
        const big = state.screenData || {}
        const safeNum = (v) => {
          const n = Number(v)
          return isNaN(n) ? 0 : n
        }
        // 周期到字段的映射（订单数）
        const mapOrdersKey = {
          recent7days: 'jczhengding_week_dingdan',
          month: 'jczhengding_yue_dingdan',
          halfyear: 'jczhengding_bannian_dingdan',
          quarter: 'jczhengding_ji_dingdan'
        }
        const ordersKey = mapOrdersKey[currentPeriod] || mapOrdersKey.quarter
        const totalOrders = safeNum(big[ordersKey])

        // 非周期字段：2025总码洋、25秋总码洋 - 适配新接口格式
        // 新接口返回格式: { "today_amount": "434022653.56", "tb": "-27.24" }
        const totalAmount2025Data = big['jczhengding_2025mayang']
        const autumnAmount25Data = big['jczhengding_25qiu']
        
        // 处理2025总码洋数据
        let totalAmount2025 = 0
        let totalAmount2025Tb = 0
        if (totalAmount2025Data && typeof totalAmount2025Data === 'object') {
          totalAmount2025 = safeNum(totalAmount2025Data.today_amount || totalAmount2025Data.amount)
          totalAmount2025Tb = safeNum(totalAmount2025Data.tb)
        } else {
          totalAmount2025 = safeNum(totalAmount2025Data)
        }
        
        // 处理25秋总码洋数据
        let autumnAmount25 = 0
        let autumnAmount25Tb = 0
        if (autumnAmount25Data && typeof autumnAmount25Data === 'object') {
          autumnAmount25 = safeNum(autumnAmount25Data.today_amount || autumnAmount25Data.amount)
          autumnAmount25Tb = safeNum(autumnAmount25Data.tb)
        } else {
          autumnAmount25 = safeNum(autumnAmount25Data)
        }

        const payload = {
          period: currentPeriod,
          totalOrders,
          totalAmount2025,
          autumnAmount25,
          // 新增同比字段
          totalAmount2025Tb,
          autumnAmount25Tb
        }
        commit('SET_TEXTBOOK_STATISTICS', payload)
      } catch (error) {
        console.error('获取教材征订统计失败:', error)
        commit('SET_TEXTBOOK_STATISTICS', {
          period: currentPeriod,
          totalOrders: 0,
          totalAmount2025: 0,
          autumnAmount25: 0,
          // 新增同比字段默认值
          totalAmount2025Tb: 0,
          autumnAmount25Tb: 0
        })
      }
    },
    // 获取订单码洋同比数据（使用大屏 dingdan 字段派生：以2025年zhou字段作为基准x轴点，仅匹配zhou_2字段中同期数据）
    async fetchOrderComparison({ commit, state }) {
      try {
        const big = state.screenData || {}
        const list = Array.isArray(big.dingdan) ? big.dingdan : []
        const safeNum = (v) => {
          const n = Number(v)
          return isNaN(n) ? 0 : n
        }

        // 首先收集所有2025年的zhou字段作为基准x轴点
        const baselineWeeks = new Set()
        const weekMapping = new Map() // zhou -> zhou_2 的映射关系
        const currentYearData = new Map() // zhou -> { amount, orders }
        const lastYearData = new Map() // zhou_2 -> { amount, orders }

        // 收集2025年数据作为基准
        for (const item of list) {
          const year = Number(item?.nian)
          const week = Number(item?.zhou)
          const week2 = Number(item?.zhou_2)
          
          if (year === 2025 && week) {
            baselineWeeks.add(week)
            if (week2) {
              weekMapping.set(week, week2) // 建立zhou到zhou_2的映射
            }
            currentYearData.set(week, {
              amount: safeNum(item?.mayang),
              orders: safeNum(item?.sl)
            })
          }
          
          // 收集2024年数据，使用zhou_2字段
          if (year === 2024 && week2) {
            lastYearData.set(week2, {
              amount: safeNum(item?.mayang),
              orders: safeNum(item?.sl)
            })
          }
        }

        // 计算周区间标签（以 2025 年为基准，ISO 8601：周一为一周起始，周日为结束）
        const isoWeekMonday = (year, week) => {
          const jan4 = new Date(Date.UTC(year, 0, 4))
          const jan4Dow = (jan4.getUTCDay() + 6) % 7 // 0=Mon..6=Sun
          const mondayWeek1 = new Date(jan4)
          mondayWeek1.setUTCDate(jan4.getUTCDate() - jan4Dow)
          const mondayOfWeek = new Date(mondayWeek1)
          mondayOfWeek.setUTCDate(mondayWeek1.getUTCDate() + (week - 1) * 7)
          return mondayOfWeek
        }
        const fmt = (d) => {
          const y = d.getUTCFullYear()
          const m = d.getUTCMonth() + 1
          const day = d.getUTCDate()
          return `${y}.${m}.${day < 10 ? '0' + day : day}`
        }

        // 仅处理2025年基准周数，并尝试匹配zhou_2字段中的同期数据
        const sortedWeeks = Array.from(baselineWeeks).sort((a, b) => a - b)
        const dates = []
        const orders = []
        const amounts = []
        
        for (const week of sortedWeeks) {
          const currentData = currentYearData.get(week)
          const matchWeek2 = weekMapping.get(week) // 获取对应的zhou_2值
          const lastData = matchWeek2 ? lastYearData.get(matchWeek2) : null // 使用映射的zhou_2值查找去年数据
          
          // 只有当前年数据存在时才添加到结果中（基准要求）
          if (currentData) {
            // 生成周区间标签
            const startMon = isoWeekMonday(2025, week)
            const endSun = new Date(startMon)
            endSun.setUTCDate(startMon.getUTCDate() + 6)
            dates.push(`${fmt(startMon)}~${fmt(endSun)}`)
            
            // 添加数据，如果zhou_2中没有匹配的数据则为0
            orders.push({ 
              currentYear: currentData.orders, 
              lastYear: lastData ? lastData.orders : 0 
            })
            amounts.push({ 
              currentYear: currentData.amount, 
              lastYear: lastData ? lastData.amount : 0 
            })
          }
        }

        commit('SET_ORDER_COMPARISON', { dates, orders, amounts })
      } catch (error) {
        console.error('获取订单码洋同比数据失败:', error)
        commit('SET_ORDER_COMPARISON', { dates: [], orders: [], amounts: [] })
      }
    },
    // 获取市州渠道对比数据（从 screenData 派生：合并线上/线下，补零，计算总额与排名）
    // 获取各市州渠道对比数据（支持静默刷新）
    async fetchCityChannelComparison({ commit, state }, period = null) {
      try {
        // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
        const currentPeriod = period || state.cityChannelComparison.period || 'today'
        
        const big = state.screenData || {}
        
        // 根据当前区域级别动态获取城市/区县列表
        const getCitiesList = () => {
          const { level, adcode } = state.currentRegion
          // 使用mapRegion配置获取区县/城市列表
          const { getRegionList } = require('@/components/Modules/mapRegion')
          return getRegionList(adcode, level)
        }
        
        const targetCities = getCitiesList()
        
        // 按周期选择线上/线下源数组
        let onlineArr = []
        let offlineArr = []
        switch (currentPeriod) {
          case 'today':
            onlineArr = Array.isArray(big.qudao_ri_xianshang) ? big.qudao_ri_xianshang : []
            offlineArr = Array.isArray(big.qudao_day_xianxia) ? big.qudao_day_xianxia : []
            break
          case 'week':
            onlineArr = Array.isArray(big.qudao_zhou_xianshang) ? big.qudao_zhou_xianshang : []
            offlineArr = Array.isArray(big.qudao_week_xianxia) ? big.qudao_week_xianxia : []
            break
          case 'month':
          default:
            onlineArr = Array.isArray(big.qudao_yue_xianshang) ? big.qudao_yue_xianshang : []
            offlineArr = Array.isArray(big.qudao_yue_xianxia) ? big.qudao_yue_xianxia : []
            break
        }

        const safeNum = (v) => {
          const n = Number(v)
          return isNaN(n) ? 0 : n
        }

        // 获取城市名称的统一方法
        const nameOf = (item) => String(item?.name || item?.cityName || '').trim()

        // 索引映射便于查找
        const onlineMap = new Map()
        const offlineMap = new Map()
        
        // 处理线上数据 - 使用sl字段
        for (const it of onlineArr) {
          const nm = nameOf(it)
          if (!nm) continue
          const cur = onlineMap.get(nm) || 0
          // 线上数据使用sl字段
          onlineMap.set(nm, cur + safeNum(it?.sl || it?.my || it?.salesAmount || it?.amount || it?.value))
        }
        
        // 处理线下数据 - 使用指定字段
        for (const it of offlineArr) {
          const nm = nameOf(it)  // 获取城市名称
          if (!nm) continue
          const cur = offlineMap.get(nm) || 0
          // 线下数据使用指定的数值字段（根据需求：线下使用name字段对应的数值）
          // 这里的name可能指的是数据中的某个数值字段，不是城市名称
          // 先尝试常见的数值字段
          const value = safeNum(it?.sl || it?.my || it?.salesAmount || it?.amount || it?.value)
          offlineMap.set(nm, cur + value)
        }

        // 确保所有目标地区都有数据输出
        const cities = targetCities.map(cityName => {
          const onlineVal = onlineMap.get(cityName) || 0
          const offlineVal = offlineMap.get(cityName) || 0
          const totalAmount = onlineVal + offlineVal
          return {
            cityName,
            channels: [
              { channelName: '线上', salesAmount: onlineVal },
              { channelName: '线下', salesAmount: offlineVal }
            ],
            totalAmount,
            ranking: 0 // 先占位，后续根据排序赋值
          }
        })

        // 根据总额排序并标注排名
        cities.sort((a, b) => b.totalAmount - a.totalAmount)
        cities.forEach((c, idx) => { c.ranking = idx + 1 })

        commit('SET_CITY_CHANNEL_COMPARISON', { period: currentPeriod, cities })
      } catch (error) {
        console.error('获取市州渠道对比数据失败:', error)
        commit('SET_CITY_CHANNEL_COMPARISON', { period: currentPeriod, cities: [] })
      }
    },
    // 切换区域并重新获取数据
    async switchRegion({ commit, dispatch }, { level, name, mapName, adcode }) {
      try {
        // 更新区域状态
        await dispatch('updateCurrentRegion', { level, name, mapName, adcode })
        
        // 重新获取所有数据
        await dispatch('fetchAllData')
      } catch (error) {
        console.error('区域切换失败:', error)
        throw error
      }
    },
    // 重置所有数据的action
    async resetAllData({ commit }) {
      commit('RESET_ALL_DATA')
      // 添加短暂延迟确保状态重置完成
      await new Promise(resolve => setTimeout(resolve, 100))
      console.log('数据重置操作完成')
    }
  },
  getters: {
    // 当前区域状态相关
    currentRegion: state => state.currentRegion,
    currentRegionLevel: state => state.currentRegion.level,
    currentRegionName: state => state.currentRegion.name,
    currentRegionMapName: state => state.currentRegion.mapName,
    currentRegionAdcode: state => state.currentRegion.adcode,
    isProvinceLevel: state => state.currentRegion.level === 'province',
    isCityLevel: state => state.currentRegion.level === 'city',
    // 图书多元各时间维度
    tushuduoyuanToday: state => state.tushuduoyuan.day,
    tushuduoyuanWeek: state => state.tushuduoyuan.week,
    tushuduoyuanMonth: state => state.tushuduoyuan.month,
    tushuduoyuanPeriod: state => state.tushuduoyuan.period,
    // 获取当前渠道销售时间段
    currentChannelPeriod: state => state.channelSales.period,
    // 获取当前销售大类时间段
    currentCategoryPeriod: state => state.salesCategory.period,
    // 获取当前教材征订时间段
    currentTextbookPeriod: state => state.textbookStatistics.period,
    // 获取当前市州对比时间段
    currentCityPeriod: state => state.cityChannelComparison.period,
    // 获取当前湖南地图时间段
    currentMapPeriod: state => state.hunanMapData.period,
    // 检查数据是否加载完成
    isDataLoaded: state => {
      return state.channelSales.channels.length > 0 &&
             state.salesCategory.categories.length > 0
    }
  }
})